import { render, staticRenderFns } from "./ModalConfirmation.vue?vue&type=template&id=62b7c61c&"
import script from "./ModalConfirmation.vue?vue&type=script&lang=ts&"
export * from "./ModalConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports